import { Currency } from '@components/UIKit/Currency/Currency';
import { useTranslation } from '@hooks/useTranslation';
import cn from 'classnames';
import React, { FC } from 'react';
import s from './toyCartItem.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { ICartItemToys } from '@services/store/helpers/cart';
interface SelectedItemProps {
  figure: ICartItemToys['figures'][0];
  editHandler: () => void | Promise<void>;
}
export const SelectedItem: FC<SelectedItemProps> = ({
  figure,
  editHandler
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    instanceId,
    price,
    currency
  } = figure;
  return <div className={s.selectedItem} data-sentry-component="SelectedItem" data-sentry-source-file="SelectedItem.tsx">
            <div className={cn(s.selectedItem__instanceId, '_instanceId', '_ellipsis')}>
                #{instanceId}
            </div>
            <div className={s.selectedItem__currency}>
                <Currency amount={price} currency={currency} data-sentry-element="Currency" data-sentry-source-file="SelectedItem.tsx" />
            </div>
            <Button id='default_button' className={s.selectedItem__edit} size={'small'} color={'Transparent'} onClick={editHandler} data-sentry-element="Button" data-sentry-source-file="SelectedItem.tsx">
                {tr({
        id: 'edit'
      })}
            </Button>
        </div>;
};